export default __webpack_public_path__ + "static/highlight-5-7d039696d048ff78b8517a8f8fd49e3c.svg";